const groupTree = groups => {
  const tree = {};
  for (const key in groups) {
    const group = groups[key];
    if (!tree[group.id]) tree[group.id] = {};
    tree[group.id].data = group;
    tree[group.id].children = {
      ...tree[group.id].children
    };
    if (group.parent_group_id) {
      if (!tree[group.parent_group_id]) tree[group.parent_group_id] = { data: {} };
      tree[group.parent_group_id].children = {
        ...tree[group.parent_group_id].children,
        [group.id]: tree[group.id]
      };
    }
  }
  for (const key in tree) {
    if (tree[key].data.parent_group_id) {
      delete tree[key];
    }
  }
  return tree;
};

export default groupTree;
